import Axios from '../axios.js'

/**
 * 工单工作流接口
 */
export default {
	/**
	 * 分页获取工作流列表
	 */
	getFlowLimit: (pageIndex, pageSize, success, failure) => {
		Axios.post('/workFlow/getFlowLimit.do', {
			pageIndex,
			pageSize
		}, success, failure);
	},
	/**
	 * 根据流id获取工作流模板详细信息包括（节点-节点处理人-操作项-操作步骤）
	 * @param {Long} flowId 工作流id
	 */
	getFlowTree: (flowId, success, failure) => {
		Axios.post('/workFlow/getFlowTree.do', {
			flowId
		}, success, failure);
	},
	/**
	 * 添加工作流节点
	 * @param {String} name 工作流名称
	 * @param {int} flowType 0_公有流,1_私有流
	 * @param {JSONArray} nodes 工作流模板详细信息
	 * @param {String} groupId 分组id
	 * 
	 */
	addFlow: (name, flowType, nodes,groupId, success, failure) => {
		Axios.post('/workFlow/addFlow.do', {
			name,
			flowType,
			nodes,
			groupId,
		}, success, failure);
	}, 
	
	/**
	 * 修改工作流节点
	 * @param {String} name 工作流名称
	 * @param {int} flowType 0_公有流,1_私有流
	 * @param {JSONArray} nodes 工作流模板详细信息
	 * @param {String} groupId 分组id
	 * 
	 */
	updateFlow: (flowId, name, flowType, nodes,groupId, success, failure) => {
		Axios.post('/workFlow/updateFlow.do', {
			flowId,
			name,
			flowType,
			nodes,
			groupId,
		}, success, failure);
	},
	/**
	 * 删除工作流下所有信息
	 * @param {Long} flowId 工作流id
	 */
	deleteFlow: (flowId, success, failure) => {
		Axios.post('/workFlow/deleteFlow.do', {
			flowId
		}, success, failure);
	},
}